module.exports = __webpack_public_path__ + "img/dt.8746a11f.jpg";